import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { makeApiCall } from "src/api/apiRequests";
import API_HEADERS from "src/api/apiConfig";
import API_PATHS from "src/api/apiPaths";
import FLASH_MESSAGES from "src/helpers/FlashMessages";
import moment from "moment";

interface ShowEvaluationProps {
  onShowModal: boolean;
  setShowModal: (visible: boolean) => void;
  evaluationId: number;
  childName: string;
}

const ShowEvaluation: React.FC<ShowEvaluationProps> = ({
  onShowModal,
  setShowModal,
  evaluationId,
  childName,
}) => {
  const { t } = useTranslation();

  const [evaluationDate, setEvaluationDate] = useState<Date | null>(null);
  const [comment, setComment] = useState<string>("");

  const [loading, setLoading] = useState<boolean>(true);

  const onClose = () => {
    setShowModal(false);
  };

  const fetchEvaluation = async (): Promise<void> => {
    try {
      const response: any = await makeApiCall<ResponseType>(
        API_PATHS.childGetEvaluation(evaluationId),
        "GET",
        API_HEADERS.authenticated
      );

      setComment(response.evaluation.evaluation);
      setEvaluationDate(new Date(response.evaluation.evaluation_date));

      setLoading(false);
    } catch (error: any) {
      FLASH_MESSAGES.errorMsg(error.response.data.error);
      onClose();
    }
  };

  useEffect(() => {
    fetchEvaluation();
  }, []);

  return (
    <Modal
      isOpen={onShowModal && !loading}
      toggle={() => onClose()}
      size="md"
      centered
    >
      <ModalHeader
        className="text-dark font-size-15"
        toggle={() => onClose()}
        tag="span"
      >
        {childName}
      </ModalHeader>
      <ModalBody>
        <div className="modal-note">
          {t("evaluations_view_modal_desc") + " " + childName}
        </div>
        <div className="modal-info-block">
          <div className="row">
            <div className="info col-12 col-sm-6">
              <span className="label">
                {t("evaluations_view_modal_date_label")}
              </span>
              <span className="item">
                {moment(evaluationDate).format("DD-MM-YYYY")}
              </span>
            </div>
            <div className="info col-12">
              <span className="label">
                {t("evaluations_view_modal_evaluation_label")}
              </span>
              <span className="item">{comment}</span>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          className="button-white"
          type="button"
          onClick={() => onClose()}
        >
          {t("evaluations_view_modal_close_button")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ShowEvaluation;
